/**
 * 支付宝签约相关接口
 */
import requestDefault from '@/shared/utils/request';
import type {
  AlipaySignQueryParams,
  AlipaySignInfoType,
  AlipaySignApplyResponse,
  AlipayCapitalListResponse,
} from './types';

/**
 * 查询支付宝签约状态
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/420333
 */
export const queryAlipaySignState = (
  params: AlipaySignQueryParams,
): Promise<AlipaySignInfoType> => requestDefault.postGate('f.repayment.alipay.sign.state', { ...params }, {
  showLoading: undefined,
  showErrMsg: undefined,
});

/**
 * 查询支持的资方列表
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/420353
 */
export const queryAlipaySignCapitalList = (): Promise<AlipayCapitalListResponse> => requestDefault.postGate('f.repayment.alipay.sign.capitalList', {}, {
  showLoading: undefined,
  showErrMsg: undefined,
});

/**
 * 申请支付宝签约
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/420345
 */
export const applyAlipaySign = (signal: AbortSignal): Promise<AlipaySignApplyResponse> => requestDefault.postGate('f.repayment.alipay.sign.apply', {}, { signal });
